// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getMeasurementReadings} from '../../shared/repositories';

export const updateAmountOfUseHistory = pin =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const payload = await getMeasurementReadings(pin);

            dispatch({
                payload,
                property: 'amountOfUseHistory',
                type: actions.READ_MEASUREMENT_READINGS_SUCCESS
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/product/details/action-creators/amount-of-use-history.js